<template>
    <div class="providerSection">
        <h1 style="margin: 0 auto;">
            <v-icon
                v-if="screen_width > 390"
                x-large
                elevation="10"
                class="white--text"
                style="height: 50px; width: 50px; background-color: #009688; border-radius: 25px; margin-right: 2%;"
            >
                {{ mdiLinkVariant }}
            </v-icon>
            <span>Link / Unlink Providers</span>
        </h1>
        <v-scroll-x-reverse-transition>
            <v-alert
                v-if="message.enable"
                class="notification"
                :type="message.status === 201 ? 'success' : 'error'"
            >
                {{ message.state }}
                <v-progress-linear
                    v-model="value"
                    height="6"
                    :color="message.status === 201 ? 'success darken-1' : 'error darken-1'"
                    style="position: absolute; bottom: 0; width: 100%; right: 0; border-radius: 0 0 5px 5px;"
                />
            </v-alert>
        </v-scroll-x-reverse-transition>
        <v-card
            class="docInfoBody"
            elevation="10"
            style="margin: 2% auto 0 auto; position: relative;"
        >
            <v-card-title>
                <v-autocomplete
                    v-model="msuMain"
                    clearable
                    autocomplete="nope"
                    :items="combinedItems"
                    label="Hospital or Clinic Name"
                    item-text="combinedText"
                    item-value="hosp_msu_code"
                    :item-style="{ height: '30px' }"
                >
                    <template #selection="data">
                        <span style="height: 37px; margin: 0 0 2px 0; padding: 0"><v-chip class="white--text" color="teal darken-1" style="margin-right: 5px">{{ data.item.hosp_msu_code }}</v-chip>{{ data.item.hosp_name }}</span>
                    </template>
                    <template #item="data">
                        <p style="margin: 0 0 10px 0; padding: 10px 0 0 0; height: 40px;">
                            <v-chip class="white--text" color="teal darken-1" style="margin: 3px 5px 0 0;">
                                {{ data.item.hosp_msu_code }}
                            </v-chip><span style="margin: 0; padding: 0">{{ data.item.hosp_name }}</span>
                        </p>
                    </template>
                </v-autocomplete>
                <v-spacer />
                <AddLink
                    :msu-main="msuMain"
                    @addNotif="addNotif"
                />
            </v-card-title>
            <v-data-table
                :headers="headers"
                :items="msuMain ? showProviderLinksData && showProviderLinksData.data ? showProviderLinksData.data : [] : []"
                :items-per-page="10"
                class="elevation-1"
            >
                <template #[`item.ACTIONS`]="{ item }">
                    <v-btn
                        small
                        color="error"
                        @click="unlink(item.hosp_msu_code)"
                    >
                        <v-icon
                            small
                        >
                            {{ mdiLinkVariantMinus }}
                        </v-icon>&nbsp;unlink
                    </v-btn>
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>

<script>
import AddLink from './AddLink.vue'
import { mapActions, mapGetters } from 'vuex'
import {
    mdiLinkVariant,
    mdiLinkVariantMinus
} from '@mdi/js'
export default {
    components: {
        AddLink
    },
    data: ()=>({
        mdiLinkVariant,
        mdiLinkVariantMinus,
        value: 0,
        bufferValue: 0,
        interval: null,
        message: {
            state: 'this is a test',
            status: 201,
            enable: false
        },
        msuMain: null,
        msuAffl: null,
        loading: false,
        headers: [
            { text: 'MSU Code', value: 'hosp_msu_code', sortable: false },
            { text: 'Hospital or Clinic Name', value: 'hosp_name', sortable: true },
            { text: 'Actions', value: 'ACTIONS', sortable: false }
        ],
        screen_width: document.documentElement.clientWidth + 9
    }),
    computed: {
        ...mapGetters(['unlinkProvidersData', 'fetchProvidersData', 'showProviderLinksData']),
        combinedItems() {
            if (!this.fetchProvidersData || !this.fetchProvidersData.data) return []
            return this.fetchProvidersData.data.map(item => ({
                ...item,
                combinedText: `${item.hosp_msu_code} ${item.hosp_name}`
            }))
        }
    },
    watch: {
        fetchProvidersData(newVal) {
            if (newVal) this.loading = false
        },
        async msuMain(newVal) {
            if (newVal) await this.getProviderLinks(newVal)
        },
        async unlinkProvidersData(newVal) {
            if (newVal) {
                let data = { state: newVal.state, status: newVal.status === 200 ? 201 : newVal.status }
                if (data.status === 201) await this.getProviderLinks(this.msuMain)
                this.addNotif(data)
            }
        },
        async message(newVal) {
            if (newVal) {
                setTimeout(() => {
                    this.message.enable = false
                }, 4000)

                this.value = 0         // Initialize value to 0

                // Total duration is 4000ms, so increment value every 40ms by 1 to reach 100 in 4000ms
                const incrementRate = 40  // Set interval duration (ms)
                const step = 108 / (4000 / incrementRate)  // Calculate step to increment per interval

                this.interval = setInterval(() => {
                    this.value += step   // Increment value by calculated step
                    if (this.value >= 100) {  // Stop when value reaches or exceeds 100
                        clearInterval(this.interval)
                        this.value = 100  // Ensure value is set exactly to 100
                    }
                }, incrementRate)  // Interval for 40ms
            }
        }
    },
    async mounted(){
        window.addEventListener('resize', this.onResize)
        this.loading = true
        await this.getProviders()
    },
    destroyed(){
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        ...mapActions(['getCsrfToken', 'fetchProviders', 'showProviderLinks', 'unlinkProviders']),
        addNotif(data) {
            const notifData = {
                enable: true,
                state: data.state,
                status: data.status
            }
            this.message = notifData
        },
        async unlink(MSU_AFFL) {
            // await this.getCsrfToken()
            this.unlinkProviders({ MSU_MAIN: this.msuMain, MSU_AFFL })
        },
        resetField() {
            this.$refs.msuMain.reset()
            this.$refs.msuAffl.reset()
        },
        async validate () {
            if (this.$refs.form.validate()) {
                const arg = {
                    MSU_MAIN: this.msuMain,
                    MSU_AFFL: this.msuAffl
                }
                await this.linkProviders(arg)
            }
        },
        onResize() {
            this.screen_width = document.documentElement.clientWidth
            this.screen_width = this.screen_width + 9
        },
        async getProviderLinks(MSU_C) {
            // await this.getCsrfToken()
            this.showProviderLinks({ MSU_C })
        },
        async getProviders() {
            // await this.getCsrfToken()
            this.fetchProviders()
        }
    }
}
</script>

<style scoped>
h1 {
    font-size: 25px;
    padding: 10px;
    border-bottom: 1px solid #bbb;
}
.docInfoBody {
    margin-top: 5%;
    padding: 3%;
}
.v-list-item {
    height: 10px;
}
@media (max-width: 380px) {
  .notification {
    z-index: 400;
    width: auto;
    position: fixed;
    top: 78px;
    right: 7%;
  }
}
@media (max-width: 599px) {
  .notification {
    z-index: 400;
    width: auto;
    position: fixed;
    top: 78px;
    right: 7%;
  }
}
@media (min-width: 599px) and (max-width: 1264px) {
  .notification {
    z-index: 400;
    width: auto;
    position: fixed;
    top: 78px;
    right: 7%;
  }
}
@media (min-width: 1264px) {
  .notification {
    z-index: 400;
    width: auto;
    position: fixed;
    top: 18px;
    right: 7%;
  }
}
</style>
